'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { OmiziAuthProvider } from '@/components/auth/omizi-auth-provider'
import { ThemeProvider } from '@/components/theme-provider'
import { ReactNode } from 'react'

const queryClient = new QueryClient()

export function Providers({ children }: { children: ReactNode }) {
  return (
    <OmiziAuthProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider
          attribute="class"
          defaultTheme="system"
          enableSystem
          disableTransitionOnChange
        >
          {children}
        </ThemeProvider>
      </QueryClientProvider>
    </OmiziAuthProvider>
  )
}
